import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { ActivityProcessParametrizationService } from '../proxy/controlling/controllers/activity-process-parametrization.service';
import { WbsService } from '../proxy/controlling/controllers/wbs.service';
import { ProductivityHourService } from '@woodsupply/proxy/wood-supply/controllers/productivity-hour.service';
import { MobileCategoryService } from '@woodsupply/proxy/wood-supply/controllers/mobile-category.service';

FieldBuilder.setNamespace('Controlling');

export const HARVESTACTIVITYPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isProgrammedHour', 'Entity.HarvestActivityParameter.IsProgrammedHour')
    .build(),
  FieldBuilder
    .checkbox('isWorkedHour', 'Entity.HarvestActivityParameter.IsWorkedHour')
    .build(),
  FieldBuilder
    .checkbox('isDistributionHour', 'Entity.HarvestActivityParameter.IsDistributionHour')
    .build(),
  FieldBuilder
    .checkbox('shouldCheckForOverlappingHour', 'Entity.HarvestActivityParameter.ShouldCheckForOverlappingHour')
    .build(),
  FieldBuilder
    .checkbox('applyMaintenanceCheck', 'Entity.HarvestActivityParameter.ApplyMaintenanceCheck')
    .build(),
  FieldBuilder
    .checkbox('inStand', 'Entity.HarvestActivityParameter.InStand')
    .build(),
  FieldBuilder
    .checkbox('hasSample', 'Entity.HarvestActivityParameter.HasSample')
    .build(),
  FieldBuilder
    .foreignKey('activityProcessParametrizationId', 'Entity.ActivityProcessParametrization', ActivityProcessParametrizationService)
    .required()
    .display('name')
    .keyField('id')
    .hideInChildForms()
    .build(),
  FieldBuilder
    .foreignKey('wbsId', 'Entity.Wbs', WbsService)
    .displayFromNested('wbs.name')
    .sortBy('wbs.name')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('productivityHourId', 'Entity.HarvestActivityParameter.ProductivityHour', ProductivityHourService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('mobileCategoryId', 'Entity.HarvestActivityParameter.MobileCategory', MobileCategoryService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const HARVESTACTIVITYPARAMETER_CONFIG = {
  entityName: 'HarvestActivityParameter',
  localizationKey: 'Controlling::Entity.HarvestActivityParameter',
  fields: HARVESTACTIVITYPARAMETER_FIELDS,
  permission: 'ControllingActivities.HarvestActivityParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
